import { useModals } from 'almanac-ui/Modal'
import { Button } from 'blaze-ui/Button'
import { RequestAnotherReviewModal } from '../RequestAnotherReviewModal/RequestAnotherReviewModal'
import { InformalFeedbackRequest } from 'api/clients/InformalFeedbackRequestsClient'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { RequestAnotherReviewDrawer } from '../RequestAnotherReviewModal/RequestAnotherReviewDrawer'
import { ButtonProps } from 'blaze-ui/Button/Types'
import useResponsiveFunction from 'hooks/useResponsiveFunction'

interface Props {
  request: InformalFeedbackRequest
}

export const RequestAnotherReviewButton = observer(({ request, ...props }: Props & ButtonProps) => {
  const { drawersStore } = useRootStore()
  const { openModal } = useModals()

  const openRequestAnotherReview = useResponsiveFunction({
    mobileFunction: () => drawersStore.openDrawer(RequestAnotherReviewDrawer, { request }),
    defaultFunction: () => openModal(RequestAnotherReviewModal, { request }),
  })

  return (
    <Button {...props} onPress={openRequestAnotherReview}>
      Request Another Review
    </Button>
  )
})
